import {
  FETCH_SESSION_ATTENDANCE_REQUEST,
  FETCH_SESSION_ATTENDANCE_SUCCESS,
  FETCH_SESSION_ATTENDANCE_FAILURE,
  FETCH_GROUP_ATTENDANCE_SUCCESS,
} from './actions';
import { ApiResponseHelper } from 'omni-common-ui';
import is from 'is_js';
import { Map, List } from 'immutable';
import {
  convertBackendAttendanceStatusToAttendanceStatus,
} from 'data/SessionsAttendance/status';
import SessionAttendance from './model';

const setAttendanceStatusesInSession = (session) => {
  if (is.not.array(session)) {
    return session;
  }

  return new List(session.map((student) => {
    const parsedSession = Object.assign({}, student, {
      attendanceStatus: convertBackendAttendanceStatusToAttendanceStatus(student.attendanceStatus),
    });
    return SessionAttendance.create(parsedSession);
  }));
};

const groupAttendanceSuccessState = (attendances, state) => {
  let result = state;
  Object.keys(attendances).forEach((key) => {
    const data = ApiResponseHelper.create(setAttendanceStatusesInSession(attendances[key]));
    result = result.set(`${key}`, data);
  });
  return result;
};

export default function sessionsAttendance(state = new Map(), action) {
  switch (action.type) {
    case FETCH_SESSION_ATTENDANCE_REQUEST:
      return state.set(`${action.id}`, ApiResponseHelper.create({ loading: true }));
    case FETCH_SESSION_ATTENDANCE_SUCCESS: {
      const data = ApiResponseHelper.create(setAttendanceStatusesInSession(action.payload));
      return state.set(`${action.id}`, data);
    }
    case FETCH_GROUP_ATTENDANCE_SUCCESS: {
      return groupAttendanceSuccessState(action.payload, state);
    }
    case FETCH_SESSION_ATTENDANCE_FAILURE:
      return state.set(`${action.id}`, ApiResponseHelper.create(action.error));
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./data/SessionsAttendance/reducer.js